import { render, staticRenderFns } from "./SendWishlistMailNotification.vue?vue&type=template&id=72f643fc&"
import script from "./SendWishlistMailNotification.vue?vue&type=script&lang=js&"
export * from "./SendWishlistMailNotification.vue?vue&type=script&lang=js&"
import style0 from "./SendWishlistMailNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports